import React, { Component } from 'react';
import PropTypes from 'prop-types';
import throttle from 'lodash.throttle';
import createQuill from './Quill';

class QuillTextArea extends Component {
  constructor(props) {
    super(props);
    this.quill = null;
    this.editor = null;
    this.state = {
      lastUpdate: false,
    };
  }

  componentDidMount = () => {
    this.quill = createQuill(this.editor, {
      modules: {
        toolbar: false,
        keyboard: { bindings: { noEnter: { key: 13, handler: () => true } } },
      },
      formats: ['link'],
    });

    this.quill.on('text-change', this.handleTextChange);

    this.quill.root.addEventListener('blur', () => {
      const { save } = this.props;
      save?.();
    });

    this.quill.root.addEventListener('focus', () => {
      const { save } = this.props;
      save?.();
    });

    if (this.props.value) this.handleSetCurrentContents(this.props.value);
  };

  handleTextChange = () => {
    if (!this.props.isFetching) {
      const newValue = this.handleGetCurrentContents();
      this.setState({ lastUpdate: newValue });
      const { onChange, name } = this.props;
      let attrName = name || 'value';
      if (onChange) {
        onChange({ [attrName]: newValue });
      }
      this.throttledUpdate();
    }
  };

  throttledUpdate = throttle(() => {
    const { save } = this.props;
    save?.();
  }, 3000);

  handleGetCurrentContents = () => {
    if (!this.quill) return '';
    return this.quill.container.querySelector('.ql-editor').innerHTML.replace(/>\s+</g, '>&nbsp;<');
  };

  handleSetCurrentContents = html => {
    if (!this.quill) return;
    this.quill.off('text-change', this.handleTextChange);
    this.quill.setContents(this.quill.clipboard.convert(html));
    this.quill.history.clear();
    this.quill.on('text-change', this.handleTextChange);
  };

  componentWillReceiveProps = nextProps => {
    if (this.quill) this.quill.enable(!(nextProps.isFetching || nextProps.disabled));
    if (nextProps.isFetching) this.throttledUpdate.cancel();
    if (nextProps.value !== this.props.value && nextProps.value !== this.state.lastUpdate) {
      this.handleSetCurrentContents(nextProps.value);
    }
    if (nextProps.id !== this.props.id) {
      this.setState({ lastUpdate: '' });
      this.handleSetCurrentContents(nextProps.value);
    }
  };

  handleClick = e => {
    console.log('handleClick', e.target, e.target.tagName);
    if (e.target.tagName === 'A') window.open(e.target.href, '_blank');
    this.quill.focus();
  };

  render() {
    const { id } = this.props;
    let props = {
      className: `quill-text-area ${this.props.className || ''}`,
    };
    if (id) props.id = id;

    return <div {...props} onClick={this.handleClick} ref={r => (this.editor = r)} />;
  }
}

QuillTextArea.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  save: PropTypes.func,
  isFetching: PropTypes.bool,
};

export default QuillTextArea;
